import { createContext, useContext } from 'react';
import type { LiveLlmCall, ProgressTree } from '@localagent/sdk';

export const LiveLlmCallsContext = createContext<ReadonlyMap<string, LiveLlmCall>>(new Map());

export function useLiveLlmCall(callId: string | undefined): LiveLlmCall | undefined {
  const byId = useContext(LiveLlmCallsContext);
  return callId ? byId.get(callId) : undefined;
}

export function streamingAnswerFor(
  run: ProgressTree | null | undefined,
  calls: LiveLlmCall[],
): LiveLlmCall | undefined {
  if (!run || run.status !== 'in_progress') return undefined;
  const rootIds = new Set(run.nodes.filter((n) => !n.parentId).map((n) => n.id));
  return calls
    .filter((c) => rootIds.has(c.taskId) && !c.deferred && c.content !== '' && c.toolArgs === '')
    .at(-1);
}
